<template>
  <div class="container">
    <div class="col-lg-4 col-md-7 ml-auto mr-auto">
      <form @submit.prevent="submitLogin">
        <card class="card-login card-white">
          <template slot="header">
            <img src="https://www.italmotori.com/wp-content/uploads/2017/11/Logo-Italmotori-300x49.png" alt="" />
            <!-- <h1 class="card-title">Log in</h1> -->
          </template>

          <div>
            <base-input
              v-validate="'required|email'"
              name="email"
              :error="getError('email')"
              v-model="model.email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              name="passwd"
              :error="getError('passwd')"
              v-model="model.passwd"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button native-type="submit" type="primary" class="mb-3 danger" size="lg" block>
              Login
            </base-button>
            <div class="row">
              <div class="col-6">
                <h6>
                  <router-link class="link footer-link" to="/register">
                    Create Account
                  </router-link>
                </h6>
              </div>
              <div class="col-6 text-right">
                <h6>
                  <router-link class="text-warning link footer-link" to="/reset-password">
                    Reset password
                  </router-link>
                </h6>
              </div>
            </div>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      model: {
        email: '',
        passwd: '',
        subscribe: true
      }
    };
  },
  computed: {
    ...mapState('account', ['status'])
  },
  created () {
    // reset login status
    this.logout();
  },
  methods: {
    ...mapActions('account', ['login', 'logout']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async submitLogin() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        this.login(this.model);
        // TIP use this.model to send it to api and perform login call

      }
    }
  }
};
</script>
<style>

  .footer-link{
    font-size: 13px;
    font-weight: normal;
    letter-spacing: 0.05em;
  }
  
  .login-page .card-login {
    padding: 0;
    border-radius: 0;
    border-top: 5px solid #e51b1f;
  }

  .login-page .card-login .card-body .input-group-text{
    padding: 10px;
  }

  .login-page .card-login .card-header {
    padding: 55px 0 40px;
    text-align: right;
  }
  
  .login-page .card-login .card-body,
  .login-page .card-login .card-footer {
    padding: 15px 25px;
  }

  .login-page .card-login .card-footer button {
    background: #e51b1f;
    transition: 0.35s;
  }

  .login-page .card-login .card-footer button:focus {
    background: #ca2124!important;
   
  }

  .login-page .card-login .card-footer h6 a{
    font-size: 0.75rem;
    transition: 0.35s;
    color: #666;
    opacity: 0.55;
  }

  .login-page .card-login .card-footer h6 a.text-warning{
    color: #e51b1f!important;
  }

  .login-page .card-login .card-footer h6 a:hover{
    opacity: 1;
  }

  .login-page .card-login .card-footer button:hover {
    background: #ca2124!important;
  }
  
  .login-page .card-login .card-header img {
    border-radius: 0;
    position: static;
    width: 85%;
    max-width: 300px;
  }

  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
